import { ENDPOINT } from "../config/endpoint.jsx";

export function cargaAllMedida() {
  return fetch(`${ENDPOINT}/medida`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((res) => {
    if (!res.ok) throw new Error("Respuesta no Ok");
    return res.json();
  });
}

export function cargaMedidaTipos() {
  return fetch(`${ENDPOINT}/medida/tipos`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((res) => {
    if (!res.ok) throw new Error("Respuesta no Ok");
    return res.json();
  });
}

export function createMedida(numero, medida) {
  return fetch(`${ENDPOINT}/medida`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ numero, medida }),
  }).then((res) => res.json());
}
